import { NorthEast } from "@mui/icons-material";
import React, { useEffect, useRef, useState } from "react";
import LinkBox from "../LinkBox";
import WheelOfLifeChartAlt from "../WheelOfLifeChartAlt";
import {
  StyledCardWrapper,
  StyledCard,
  StyledHeader,
  StyledTitle,
  StyledAltTitle,
  StyledBodyText,
  StyledBodyText2,
  StyledImage,
  ExpandableTextWrapper,
  ReadMoreButton,
  ReadMoreButtonText,
} from "./ContentCard.styles";
import { Tooltip } from "@mui/material";

const DEFAULT_LINK_BOX_TEXT = "Click Here";
const EXPANDABLE_HEIGHT_THRESHOLD = 60;

const ContentCard = ({
  item,
  height,
  onClick,
  clickable,
  alt,
  expandable = false,
  headerClickAble = false,
  headerOnClick,
  date,
  setDate,
  chartData,
  onLinkBoxClick,
  image,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const text2Ref = useRef(null);

  useEffect(() => {
    if (expandable && text2Ref.current) {
      setShowReadMore(
        text2Ref.current.scrollHeight > EXPANDABLE_HEIGHT_THRESHOLD
      );
    }
  }, [expandable, item?.text2]);

  const handleCardClick = () => {
    if (clickable) onClick?.();
  };

  const handleHeaderClick = () => {
    if (headerClickAble) headerOnClick?.();
  };

  const handleReadMoreClick = (e) => {
    e.stopPropagation();
    setExpanded((prev) => !prev);
  };

  const TitleComponent = alt ? StyledAltTitle : StyledTitle;
  const titleContent = alt ? `${item?.id}. ${item?.title}` : item?.title;

  const renderText2 = () => {
    if (!item?.text2) return null;
    if (expandable) {
      return (
        <ExpandableTextWrapper ref={text2Ref} isExpanded={expanded}>
          <StyledBodyText2
            hasList={item?.list}
            dangerouslySetInnerHTML={{ __html: item.text2 }}
          />
        </ExpandableTextWrapper>
      );
    }
    return (
      <StyledBodyText2
        hasList={item?.list}
        dangerouslySetInnerHTML={{ __html: item.text2 }}
      />
    );
  };

  return (
    <StyledCardWrapper>
      <StyledCard
        clickable={clickable}
        cardHeight={height || "auto"}
        onClick={handleCardClick}
      >
        <StyledHeader
          headerClickable={headerClickAble}
          cardClickable={clickable}
          onClick={handleHeaderClick}
        >
          <TitleComponent>
            <Tooltip
              placement="top"
              disableHoverListener={!item?.hasTooltip}
              enterNextDelay={1200}
              title={titleContent}
            >
              {titleContent}
            </Tooltip>
          </TitleComponent>
          {(item?.link || clickable || headerClickAble) && <NorthEast />}
        </StyledHeader>
        <StyledBodyText dangerouslySetInnerHTML={{ __html: item?.text }} />
        {(image || item?.image) && (
          <StyledImage src={image || item?.image} alt={item?.title} />
        )}
        {renderText2()}
        {item?.text3 && (
          <StyledBodyText dangerouslySetInnerHTML={{ __html: item?.text3 }} />
        )}
        {item?.linkBox && (
          <LinkBox
            title={item?.linkBoxText || DEFAULT_LINK_BOX_TEXT}
            noMt
            link={item?.link}
            onClick={onLinkBoxClick}
          />
        )}
        {headerClickAble && (
          <WheelOfLifeChartAlt
            chartData={chartData}
            date={date}
            setDate={setDate}
          />
        )}
        {expandable && showReadMore && (
          <ReadMoreButton onClick={handleReadMoreClick}>
            <ReadMoreButtonText>
              {expanded ? "Read Less" : "Read More"}
            </ReadMoreButtonText>
          </ReadMoreButton>
        )}
      </StyledCard>
    </StyledCardWrapper>
  );
};

export default ContentCard;
